import { Link, useLocation } from "react-router-dom";
import { Crown, LogOut, Ticket, Trophy, User } from "lucide-react";
import useSWR from "swr";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { InstallApp } from "./InstallApp";

export function AccountBox() {
  const { user, logout } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="h-16" />;
  if (!user)
    return (
      <div className="space-y-2">
      <div className="flex gap-2" data-testid="account-box">
        <Link to={`/login?next=${encodeURIComponent(location.pathname)}`} className="flex-1 text-center border border-[#27272A] py-2 text-xs font-bold uppercase tracking-wider hover:border-white transition-colors" data-testid="nav-login-link">Accedi</Link>
        <Link to="/register?next=/premium" className="flex-1 text-center bg-[#39FF14] text-black py-2 text-xs font-black uppercase tracking-wider hover:bg-white transition-colors" data-testid="nav-register-link">Registrati</Link>
      </div>
      <InstallApp compact />
      </div>
    );
  return (
    <div className="border border-[#27272A] p-3" data-testid="account-box">
      <div className="flex items-center gap-2 text-sm">
        <User size={14} strokeWidth={1.5} className="text-[#A1A1AA]" />
        <span className="truncate flex-1" data-testid="account-email">{user.email}</span>
        <button onClick={logout} title="Esci" data-testid="logout-button" className="text-[#A1A1AA] hover:text-[#FF3B30] transition-colors"><LogOut size={14} /></button>
      </div>
      <Link
        to="/premium"
        data-testid="nav-premium-link"
        className={`mt-3 flex items-center justify-center gap-2 py-2 text-xs font-black uppercase tracking-wider transition-colors ${user.is_premium ? "border border-[#39FF14] text-[#39FF14]" : "bg-[#39FF14] text-black hover:bg-white"}`}
      >
        <Crown size={12} /> {user.is_premium ? (user.subscription_status === "trialing" ? "Premium · prova" : "Premium attivo") : "Attiva Premium"}
      </Link>
      <Link to="/schedine" data-testid="nav-slips-link" className="mt-2 flex items-center justify-center gap-2 py-2 text-xs font-black uppercase tracking-wider border border-[#FFCC00]/60 text-[#FFCC00] hover:bg-[#FFCC00] hover:text-black transition-colors">
        <Ticket size={12} /> Schedine del giorno
      </Link>
      <Link to={user.role === "admin" ? "/admin/vincite" : "/vincite"} data-testid="nav-wins-link" className="mt-2 flex items-center justify-center gap-2 py-2 text-xs font-black uppercase tracking-wider border border-[#27272A] text-[#A1A1AA] hover:text-white transition-colors">
        <Trophy size={12} /> {user.role === "admin" ? "Gestisci vincite" : "Galleria vincite"}
      </Link>
      <div className="mt-2"><InstallApp compact /></div>
    </div>
  );
}

export function Paywall({ title, text, label = "Analisi AI Premium" }) {
  const { user } = useAuth();
  const location = useLocation();
  const loggedIn = !!user;
  const { data: plan } = useSWR("plan", () => api.get("/payments/plan").then((r) => r.data));
  const trial = (!user || !user.trial_used) && !!plan?.trial_days;
  return (
    <div className="surface-raised p-8 lg:p-10 border-[#39FF14]/40 relative overflow-hidden" data-testid="paywall">
      <div className="absolute -right-10 -top-10 w-48 h-48 bg-[#39FF14]/10 rounded-full blur-3xl" />
      <div className="relative max-w-2xl">
        <div className="label flex items-center gap-2 text-[#39FF14]"><Crown size={12} /> {label}</div>
        <h3 className="heading text-3xl lg:text-4xl font-black tracking-tighter mt-3">{title || "Sblocca i pronostici con le percentuali di fattibilità"}</h3>
        <p className="text-sm text-[#A1A1AA] mt-3">{text || "1X2, Over/Under, Goal, risultato esatto, corner, cartellini, marcatori e pronostici consigliati, calcolati dall'AI su formazioni, quote, forma, meteo e statistiche."}</p>
        <div className="flex flex-wrap gap-3 mt-6">
          <Link
            to={loggedIn ? "/premium" : `/register?next=${encodeURIComponent("/premium")}`}
            className="bg-[#39FF14] text-black font-black uppercase tracking-wider text-sm px-6 py-3 hover:bg-white transition-colors"
            data-testid="paywall-cta"
          >
            {trial ? "Prova gratis 7 giorni" : "Abbonati · 5,99 €/mese"}
          </Link>
          {!loggedIn && (
            <Link to={`/login?next=${encodeURIComponent(location.pathname)}`} className="border border-[#27272A] text-sm px-6 py-3 hover:border-white transition-colors" data-testid="paywall-login">
              Ho già un account
            </Link>
          )}
        </div>
        {trial && <p className="text-[11px] text-[#71717A] mt-4">Gratis per la prima settimana, poi 5,99 € al mese. Disdici quando vuoi.</p>}
      </div>
    </div>
  );
}
